import { isEmpty, isString, isArray } from 'lodash';

export default {
    inserted (el, binding, vnode) {
        let hasPermission = false; // 是否有操作权限
        let permissonList = []; // 按钮的权限列表
        let currentUserStr = sessionStorage.getItem('currentUserInfo');
        let userInfo = JSON.parse(currentUserStr);
        const { value } = binding;
        if (!isEmpty(value)) {
            if (isString(value)) {
                permissonList.push(value);
            } else if (isArray(value)) {
                permissonList = value;
            }
            // 过滤出所有操作权限、特殊权限的数据
            const roles = userInfo.resources.filter(item => {
                return item.resourceType === 1 || item.resourceType === 2 || item.resourceType === 4;
            });

            hasPermission = roles.some(role => {
                return permissonList.includes(role.resourceDes);
            });
        }

        // 将没有权限的DOM移除
        if (!hasPermission) {
            el.parentNode && el.parentNode.removeChild(el);
        }
    }
};



// WEBPACK FOOTER //
// ./src/directive/permission.js